import * as Yup from 'yup';
import { subYears } from 'date-fns';
import { contractSignerSchema } from '../../userFormValidations';
import { MIN_USER_AGE } from '../../../constants';
import { getYearsAgo } from '../../../helpers/dates';
import { TRAVEL_MAX_AGE } from '../../../constants/travelCalcConstants';

export const travelContractSignerSchema = contractSignerSchema.shape({
  birthday: Yup.date()
    .max(subYears(new Date(), MIN_USER_AGE), 'validationErrors.minAge')
    .min(getYearsAgo(TRAVEL_MAX_AGE + 1), 'validationErrors.maxAge')
    .nullable()
    .typeError('validationErrors.invalidDate')
    .required('validationErrors.isRequired'),
});
